import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './IconButton.module.css';

export type IconButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'aria-label'> & {
  label: string;
  icon: ReactNode;
  size?: 'sm' | 'md';
  tone?: 'danger';
};

export const IconButton = ({
  label,
  icon,
  size = 'md',
  tone,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) => (
  <button
    type={type}
    aria-label={label}
    title={label}
    data-tone={tone}
    className={[styles['button'], size === 'sm' ? styles['sm'] : '', className ?? ''].join(' ')}
    {...rest}
  >
    {icon}
  </button>
);
